import { NavigationGuard } from "vue-router";

export const requestDevStepIdGuard: NavigationGuard = async (to, from, next) => {
    if (!isNaN(Number(to.params.requestId)) && !isNaN(Number(to.params.requestDevStepId))) {
        next();
    } else {
        next({name: "not-found"});
    }
};
